// extracted by mini-css-extract-plugin
module.exports = {"img-fluid":"_3zGF5","img-thumbnail":"_3bTlY","figure":"_3TzXO","figure-img":"_2PITU","figure-caption":"_3xhHX"};